import React from "react";
import { UserContext } from "../contexts";
import { useNotificationSummary } from "./useNotificationCenter";

/**
 * Unread-count badge on the sidebar's Notifications entry. Shares the
 * react-query summary key with the header bell and the mobile topbar, so the
 * three surfaces always agree and only one poll runs.
 *
 * Renders nothing at 0 — a permanent grey "0" is noise.
 */
const NotificationsNavBadge = () => {
  const { user } = React.useContext(UserContext) ?? {};
  const { data } = useNotificationSummary(!!user);
  const count = data?.unread_count ?? 0;

  if (!user || count <= 0) return null;

  return (
    <span className="rc-sidebar__badge" aria-label={`${count} unread notifications`}>
      {count > 99 ? "99+" : count}
    </span>
  );
};

export default NotificationsNavBadge;
